export const useVinoData = (data) => {
  const categories = computed(() => {
    const vinoCategories = data.value.categories || []
    return vinoCategories.filter(
      (category) => category.__typename === 'categoriaProdottoVino_Category',
    )
  })

  const subcategories = computed(() => {
    const vinoSubcategories = data.value.categories || []
    return {
      lievitoVino: vinoSubcategories.filter(
        (category) => category.__typename === 'categoriaLievitoVino_Category',
      ),
    }
  })

  return { categories, subcategories }
}

export const useVinoItem = (categories, subcategories) => {
  const getVinoSubcategories = (categoryKey) => {
    switch (categoryKey) {
      case 'lieviti':
        return subcategories.lievitoVino
      default:
        return []
    }
  }

  const findVinoItemBySlug = (slug) => {
    let category = categories.find((category) => category.slug === slug)
    if (category) return category

    for (const category of categories) {
      const subcategoryList = getVinoSubcategories(category.key)
      const subcategory = subcategoryList.find((subcat) => subcat.slug === slug)
      if (subcategory) {
        return { ...subcategory, parent: category.title }
      }
    }

    return null
  }

  return { findVinoItemBySlug, getVinoSubcategories }
}

export const generateVinoDefaultFacetsFilters = (
  currentCategory,
  currentSubCategory = null,
) => {
  const filters = [
    [`Filtro_Categoria_Prodotto_Vino:${currentCategory.value.algoliaKey}`],
  ]
  if (currentSubCategory) {
    filters.push([
      `Filtro_Categoria_Lievito_Vino:${currentSubCategory.value.algoliaKey}`,
    ])
  }
  return filters
}
